module.exports = __webpack_public_path__ + "img/621.Machine_ailure.d1baff08.svg";